import { StateCreator } from 'zustand';
import { AccessTokenSlice } from './accessTokenSlice';
import { initialLoadableData, LoadableData, loadedData, trackLoading } from '../../utils/loadingUtils';
import {
  GetMeasurementDefinitionTypes,
  GetResearchProjectMeasurementDefinitions,
  LinkedMeasurementDefinition,
  MeasurementDefinitionType,
} from '../../../../data/MeasurementDefinitionData';

export interface MeasurementDefinitionsSlice {
  measurementDefinitions: LoadableData<ReadonlyArray<LinkedMeasurementDefinition>>;
  setMeasurementDefinitions: (measurementDefinitions: LinkedMeasurementDefinition[] | undefined) => void;
  loadMeasurementDefinitionsFromServer: (researchProjectId: string) => void;
  measurementDefinitionTypes: LoadableData<ReadonlyArray<MeasurementDefinitionType>>;
  loadMeasurementDefinitionTypesFromServer: () => void;
}

export const createMeasurementDefinitionsSlice: StateCreator<
  AccessTokenSlice & MeasurementDefinitionsSlice,
  [],
  [],
  MeasurementDefinitionsSlice
> = (set, get) => ({
  measurementDefinitions: initialLoadableData(),
  setMeasurementDefinitions: measurementDefinitions =>
    set({ measurementDefinitions: loadedData(measurementDefinitions) }),
  loadMeasurementDefinitionsFromServer: researchProjectId => {
    const accessToken = get().accessToken;

    if (accessToken === undefined) {
      return;
    }

    trackLoading(
      () => GetResearchProjectMeasurementDefinitions(researchProjectId, accessToken),
      state => set({ measurementDefinitions: state })
    );
  },
  measurementDefinitionTypes: initialLoadableData(),
  loadMeasurementDefinitionTypesFromServer: () => {
    const accessToken = get().accessToken;

    if (accessToken === undefined) {
      return;
    }

    trackLoading(
      () => GetMeasurementDefinitionTypes(accessToken),
      state => set({ measurementDefinitionTypes: state })
    );
  },
});
